<script lang="ts" setup>
import type { PropType } from 'vue'
import MeetWith from './MeetWith.vue'
import { computed } from 'vue'

const props = defineProps({
  emailDelivery: { type: Boolean, required: true },
  calendarDelivery: { type: Boolean, required: true },
  notifyBefore: { type: Number as PropType<number | null> },
  lastMetWith: { type: Number, default: -1 },
  deliveryRule: { type: String, default: 'always' }
})

const emit = defineEmits<{
  'update:emailDelivery': [value: boolean]
  'update:calendarDelivery': [value: boolean]
  'update:notifyBefore': [value: number | null]
  'update:lastMetWith': [value: number]
  'update:deliveryRule': [value: string]
}>()

const hasError = computed(() => !props.emailDelivery && !props.calendarDelivery)

function handleEmailDeliveryUpdate(value: boolean) {
  if (!value && !props.calendarDelivery) {
    emit('update:calendarDelivery', true)
  }
  emit('update:emailDelivery', value)
}

function handleCalendarDeliveryUpdate(value: boolean) {
  if (!value && !props.emailDelivery) {
    emit('update:emailDelivery', true)
  }
  emit('update:calendarDelivery', value)
}
</script>

<template>
  <div class="myCard q-pa-md">
    <h5 class="text-h5 q-mb-md">Meeting Intelligence Settings</h5>
    <h6 class="text-h6">Notification Channels</h6>

    <div class="row q-col-gutter-md full-width q-mb-md">
      <div class="col-12 col-md paddingFixerSingle">
        <div class="row">
          <q-checkbox
            :model-value="props.emailDelivery"
            @update:model-value="handleEmailDeliveryUpdate"
            :error="hasError"
          />
          <div>
            <div class="text">Email Notifications</div>
            <div class="text-caption text-grey-6">Receive meeting intelligence directly in your inbox</div>
          </div>
          <div class="q-pl-md" v-if="props.emailDelivery">
            <q-input
              :model-value="props.notifyBefore"
              @update:model-value="(val) => emit('update:notifyBefore', Number(val))"
              filled
              dense
              type="number"
              style="display: inline-block; max-width: 60px; max-height: 10px"
            />
            <span class="text-caption text-grey-6">minutes before meeting</span>
          </div>
        </div>
      </div>
      <div class="col-12 col-md paddingFixerSingle">
        <div class="row">
          <q-checkbox
            :model-value="props.calendarDelivery"
            @update:model-value="handleCalendarDeliveryUpdate"
            :error="hasError"
          />
          <div>
            <div class="text">Calendar Integration</div>
            <div class="text-caption text-grey-6">Add meeting intelligence as a private calendar event</div>
          </div>
        </div>
      </div>
    </div>

    <q-banner v-if="hasError" dense class="bg-red-1 text-red">
      Please select at least one notification method
    </q-banner>

    <MeetWith
      :model-value="props.lastMetWith"
      :delivery-rule="props.deliveryRule"
      @update:model-value="(val) => emit('update:lastMetWith', val)"
      @update:delivery-rule="(val) => emit('update:deliveryRule', val)"
    />
  </div>
</template>
